/* eslint-disable prefer-arrow/prefer-arrow-functions */
import instance from '@/services/repository';

const resource = '/plannings';

export default {
    lookup(options: any, statusId: number, workType: string, subcontractorId: string) {
        const formData = new FormData();

        for (const key in options) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        return instance
            .post(`${resource}/lookup?statusId=${statusId}&workType=${workType}&subcontractorId=${subcontractorId}`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    },
    lookupListInProjects(options: any, projectId: string) {
        const formData = new FormData();

        for (const key in options) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        return instance
            .post(`${resource}/lookupListInProjects?projectId=${projectId}`,
                formData,
                {
                    headers: { 'Content-Type': 'multipart/form-data' },
                });
    },
};
